<template>
<v-app class="vuetify-layout">
    <div class="login" v-on:keyup.enter="submit">
        <div class="container">
            <div class="logo-container">
                <img src="/images/fitbrry-logo-color-small.png" alt="">
            </div>
            <div class="form-wrap">
                <h1> {{ $page.props.lang.title || 'Welcome to' }} {{ invite.organization }}</h1>
                <p>{{ $page.props.lang.description || 'Please will form below to createa the account.' }}</p>
                <form method="POST">
                    <label>{{ $page.props.lang.email || 'Email' }}</label>
                    <v-text-field disabled v-model="invite.email" outlined solo flat dense></v-text-field>
                    <span v-if="errors.email" class="error"><p style="color:red;">{{ errors.email[0] }}</p></span>
                    <label>{{ $page.props.lang.password || 'Password' }}</label>
                    <v-text-field v-model="form.password" outlined solo flat dense type="password" name="password"></v-text-field>
                    <span v-if="errors.password" class="error"><p style="color:red;">{{ errors.password[0] }}</p></span>
                     <label>{{ $page.props.lang.confirm_password || 'Confirm Password' }}</label>
                    <v-text-field v-model="form.confirm_password" outlined solo flat dense type="password" name="confirm_password"></v-text-field>
                    <span v-if="errors.confirm_password" class="error"><p style="color:red;">{{ errors.confirm_password[0] }}</p></span>
                    <div class="actions">
                        <v-btn color="primary" @click="submit" :loading="loading" class="button">{{ $page.props.lang.createAccount || "Create Account" }}</v-btn>
                    </div>
                </form>
            </div>
        </div>
    </div>
</v-app>
</template>

<script>
export default {
     metaInfo() {
        return {
            title:  this.invite.organization+ ' - Create New Account'
        }
    },
    data() {
        return{
            errors: {},
            form: {
                password: '',
                confirm_password: '',
                id: this.invite.id,
                token: this.invite.token
            },
            loading: false
        }
    },
    props:{
        invite: Object
    },
    methods: {
        submit() {
            this.loading = true
            axios.post('/invite', this.form)
                .then(response => {
                    if(response.data.status == "OK"){
                        window.location.href = "/login";
                    }
                    this.loading = false
                })
                .catch(error => {
                    if(error.response.data.errors){
                        this.errors = error.response.data.errors;
                    }
                    this.loading = false
                })
        }
    }
}
</script>